import { bool, node } from 'prop-types';

import { getText } from 'shared/utils/Text';

import CornerLoader from '../loader/CornerLoader';

const ReductionSummary = ({ children, isEmpty, isLoading }) => (
  <div className="reductions-summary">
    <CornerLoader visible={isLoading} />
    <h2>{getText('bet-popup-conditions-header')}</h2>
    {isEmpty && !isLoading && (
      <h3>{getText('bet-popup-no-conditions-header')}</h3>
    )}
    {!isEmpty && children}
  </div>
);

ReductionSummary.propTypes = {
  children: node,
  isLoading: bool.isRequired,
  isEmpty: bool,
};

export default ReductionSummary;
